import { motion } from "framer-motion";

export default function Preloader() {
  return (
    <motion.div
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[100] bg-navy-900 flex flex-col items-center justify-center"
      data-testid="preloader"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative flex items-center justify-center w-20 h-20 border border-brand/50"
      >
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="flex items-center justify-center w-14 h-14 rounded-full bg-white p-2 overflow-hidden"
        >
          <img src="/logo.webp" alt="Early Appointments Solutions Inc. logo" className="w-full h-full object-contain" data-testid="preloader-logo" />
        </motion.span>
        <motion.span
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.5, duration: 0.8, ease: "easeInOut" }}
          className="absolute -bottom-px left-0 h-px w-full bg-brand origin-left"
          aria-hidden="true"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.6 }}
        className="mt-6 text-[10px] uppercase tracking-[0.4em] text-cream/50"
      >
        Early Appointments · Solutions Inc.
      </motion.p>
    </motion.div>
  );
}
